module.exports = __webpack_public_path__ + "static/media/defaultO.5e6f6fbb.svg";